
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/pools/[address]",
      function () {
        return require("private-next-pages/info/pools/[address].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/pools/[address]"])
      });
    }
  